export default function IconSearch({ className = "" }: { className?: string }) {
    return (
        <svg
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            className={className}
        >
            <path
                d="M10.724 10C11.5489 9.0204 12.0009 7.78067 12 6.5C12 5.41221 11.6774 4.34884 11.0731 3.44437C10.4687 2.5399 9.60976 1.83495 8.60476 1.41867C7.59977 1.00238 6.4939 0.893465 5.42701 1.10568C4.36011 1.3179 3.3801 1.84173 2.61092 2.61092C1.84173 3.3801 1.3179 4.36011 1.10568 5.42701C0.893465 6.4939 1.00238 7.59977 1.41867 8.60476C1.83495 9.60976 2.5399 10.4687 3.44437 11.0731C4.34884 11.6774 5.41221 12 6.5 12C7.78067 12.0009 9.0204 11.5489 10 10.724L13.793 14.5L14.5 13.793L10.724 10ZM6.5 11C5.60999 11 4.73996 10.7361 3.99994 10.2416C3.25992 9.74715 2.68314 9.04435 2.34254 8.22208C2.00195 7.39981 1.91284 6.49501 2.08647 5.6221C2.2601 4.74918 2.68869 3.94736 3.31802 3.31802C3.94736 2.68869 4.74918 2.2601 5.6221 2.08647C6.49501 1.91284 7.39981 2.00195 8.22208 2.34254C9.04435 2.68314 9.74715 3.25992 10.2416 3.99994C10.7361 4.73996 11 5.60999 11 6.5C10.9987 7.69307 10.5241 8.83689 9.68052 9.68052C8.83689 10.5241 7.69307 10.9987 6.5 11V11Z"
                fill="currentColor"
            />
        </svg>
    )
}
